// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as CustomerDetailTable from "./tables/CustomerDetailTable.bs.js";
import * as PartnerDetailsTable from "./tables/PartnerDetailsTable.bs.js";
import * as CrmControlledReleaseHOC from "../../../../../library/data-source/controlled-rollout/component/CrmControlledReleaseHOC.bs.js";
import * as CrmControlledReleaseContext from "../../../../../library/data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";
import * as PretendAsCallerAssetsManager from "../assets/PretendAsCallerAssetsManager.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var placeholderImage = PretendAsCallerAssetsManager.getImage("placeholder.svg");

function getPlaceHolder(param) {
  return React.createElement("div", {
              className: "place-holder"
            }, React.createElement("img", {
                  src: placeholderImage
                }), React.createElement("div", {
                  className: "place-holder-content"
                }), React.createElement("div", {
                  className: "place-holder-text"
                }, "Please enter the caller number to see the results."));
}

var Placeholder = {
  placeholderImage: placeholderImage,
  getPlaceHolder: getPlaceHolder
};

function PretendAsCallerSearchResultCmp(Props) {
  var callerNumber = Props.callerNumber;
  var callerDetail = Props.callerDetail;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match = React.useState(function () {
        return /* InitialState */0;
      });
  var setState = match[1];
  var state = match[0];
  var adminBetaPageAccessData = React.useContext(CrmControlledReleaseContext.context);
  CrmControlledReleaseHOC.getAccessType(adminBetaPageAccessData.adminBetaAccessData.page_config, "customer_profile");
  React.useEffect((function () {
          if (typeof callerDetail === "number") {
            Curry._1(setState, (function (param) {
                    return /* InitialState */0;
                  }));
          } else {
            switch (callerDetail.TAG | 0) {
              case /* Loading */0 :
                  Curry._1(setState, (function (param) {
                          return /* LoadingData */1;
                        }));
                  break;
              case /* Live */1 :
                  var data = callerDetail._0;
                  var match = data.customer;
                  var match$1 = Belt_List.length(data.partners);
                  if (match !== undefined) {
                    if (match$1 !== 0) {
                      Curry._1(setState, (function (param) {
                              return {
                                      TAG: /* CustomerAndPartners */2,
                                      _0: match,
                                      _1: data.partners,
                                      _2: 1 + Belt_List.length(data.partners) | 0
                                    };
                            }));
                    } else {
                      Curry._1(setState, (function (param) {
                              return {
                                      TAG: /* Customer */0,
                                      _0: match
                                    };
                            }));
                    }
                  } else if (match$1 !== 0) {
                    Curry._1(setState, (function (param) {
                            return {
                                    TAG: /* Partners */1,
                                    _0: data.partners,
                                    _1: Belt_List.length(data.partners)
                                  };
                          }));
                  } else {
                    Curry._1(setState, (function (param) {
                            return /* None */2;
                          }));
                  }
                  break;
              case /* Error */2 :
                  var error = callerDetail._0;
                  Curry._1(setState, (function (param) {
                          return {
                                  TAG: /* Error */3,
                                  _0: error
                                };
                        }));
                  break;
              
            }
          }
          
        }), [callerDetail]);
  var getCallerCountView = function (param) {
    if (typeof callerDetail === "number") {
      return null;
    }
    if (callerDetail.TAG !== /* Live */1) {
      return null;
    }
    var count;
    if (typeof state === "number") {
      count = 0;
    } else {
      switch (state.TAG | 0) {
        case /* Customer */0 :
            count = 1;
            break;
        case /* Partners */1 :
            count = state._1;
            break;
        case /* CustomerAndPartners */2 :
            count = state._2;
            break;
        default:
          count = 0;
      }
    }
    return React.createElement("p", {
                className: "caller-count-section"
              }, String(count) + " profiles associated with caller number ", React.createElement("span", {
                    className: "caller-number"
                  }, callerNumber));
  };
  var tmp;
  if (typeof state === "number") {
    switch (state) {
      case /* InitialState */0 :
          tmp = React.createElement("div", {
                className: "c-search-result"
              }, getPlaceHolder(undefined));
          break;
      case /* LoadingData */1 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* None */2 :
          if (callerNumber !== undefined) {
            Curry._1(workspaceDispatch.replaceTab, {
                  TAG: /* UnknownCaller */4,
                  _0: callerNumber
                });
            tmp = null;
          } else {
            tmp = null;
          }
          break;
      
    }
  } else {
    switch (state.TAG | 0) {
      case /* Customer */0 :
          Curry._1(workspaceDispatch.replaceTab, {
                TAG: /* CustomerProfileNew */2,
                _0: Belt_Option.getWithDefault(callerNumber, ""),
                _1: state._0.id
              });
          tmp = null;
          break;
      case /* Partners */1 :
          var partners = state._0;
          if (state._1 !== 1) {
            tmp = React.createElement(PartnerDetailsTable.make, {
                  partners: partners,
                  workspaceDispatch: workspaceDispatch
                });
          } else {
            var partner = Belt_List.get(partners, 0);
            Curry._1(workspaceDispatch.replaceTab, {
                  TAG: /* DriverDashboardV2 */5,
                  _0: partner.msisdn
                });
            tmp = null;
          }
          break;
      case /* CustomerAndPartners */2 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(CustomerDetailTable.make, {
                    customer: state._0,
                    workspaceDispatch: workspaceDispatch
                  }), React.createElement(PartnerDetailsTable.make, {
                    partners: state._1,
                    workspaceDispatch: workspaceDispatch
                  }));
          break;
      case /* Error */3 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: state._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "c-caller-search-result-container"
            }, getCallerCountView(undefined), tmp);
}

var make = PretendAsCallerSearchResultCmp;

export {
  Placeholder ,
  make ,
  
}
/* placeholderImage Not a pure module */
